import React, { useEffect, useState } from "react";
import { Box, TextField, Typography, Stack, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DocumentTypeCheckboxes from "./DocumentTypeCheckboxes";
const SUPPORTED_TYPES = [
  "application/pdf",
  "image/png",
  "image/jpeg",
  "image/tiff"
];

const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
export default function ControlSection({
  control,
  isActive,
  setActive,
  controls,
  setControls,
  setSelectedFile,
  selectedFile,
  removeControl
}) {
  const [fileError, setFileError] = useState(""); 
  useEffect(() => {
    if (isActive) {
      if (control.files.length > 0) {
        //  select last file of this control
        setSelectedFile(control.files[control.files.length - 1]);
      } else {
        //  no files → clear selection
        setSelectedFile(null);
      }
    }
  }, [isActive]);
  const updateControl = (key, value) => {
    setControls(
      controls.map(c =>
        c.id === control.id ? { ...c, [key]: value } : c
      )
    );
  };
  const addFiles = files => {
    setFileError(""); // reset error
  
    const validFiles = [];
    let hasError = false;
  
    files.forEach(file => {
      if (!SUPPORTED_TYPES.includes(file.type)) {
        hasError = true;
      } else if (file.size > MAX_FILE_SIZE) {
        hasError = true;
      } else {
        validFiles.push(file);
      }
    });
  
    if (hasError) {
      setFileError(
        "Supported formats: PDF, PNG, JPG, TIFF (Max 5MB)"
      );
    }
  
    if (validFiles.length > 0) {
      updateControl("files", [...control.files, ...validFiles]);
      setSelectedFile(validFiles[validFiles.length - 1]);
    }
  };

  const removeFile = fileToRemove => {
    const updatedFiles = control.files.filter(
      file => file !== fileToRemove
    );
  
    updateControl("files", updatedFiles);
  
    // ✅ if removed file was selected → clear selection
    if (
      selectedFile &&
      selectedFile.name === fileToRemove.name &&
      selectedFile.size === fileToRemove.size
    ) {
      setSelectedFile(null);
    }
  };
  return (
    <Box
      mt={2}
      p={1}
      border="1px solid #ccc"
      bgcolor={isActive ? "#fff" : "#F9F9F9"}
      sx={{ cursor: "pointer" }}
      onClick={setActive}
    >
      {/* COLLAPSED VIEW */}
     
      <Box
  display="flex"
  alignItems="center"
  justifyContent="space-between"
>
  <Typography fontWeight={600}>
    Control #: {control.controlNo || "—"}
  </Typography>

  <IconButton
    size="small"
    onClick={e => {
      e.stopPropagation(); // ✅ prevent activating section
      removeControl(control.id);
    }}
  >
    <CloseIcon fontSize="small" />
  </IconButton>
</Box>
 {!isActive && (
        <>
         
          <Typography fontSize={12} color="text.secondary">
            {control.files.length} file(s) uploaded
          </Typography>
        </>
      )}
      {/* ACTIVE VIEW */}
      {isActive && (
        <>
        
         <TextField
  label="Control #"
  size="small"
  fullWidth
  sx={{ mt: 1 }}
  value={control.controlNo}
  InputProps={{
    readOnly: Boolean(control.lockControlNo) // ✅ modal locks it
  }}
  onChange={e =>
    !control.lockControlNo &&
    updateControl("controlNo", e.target.value)
  }
/>
          <input
            type="file"
            multiple
            accept=".pdf,.png,.jpg,.jpeg,.tiff"
            style={{ marginTop: 8 }}
            onChange={e => addFiles([...e.target.files])}
          />
          {fileError && (
            <Typography color="error" fontSize={12} mt={0.5}>
              {fileError}
            </Typography>
          )}

<DocumentTypeCheckboxes
  value={control.docType}
  allowedTypes={control.allowedDocTypes}
  disabled={control.lockDocType}
  onChange={type => {
    const matched = control.allowedDocTypesMeta?.find(
      d => d.abbrevation === type.abbrevation
    );

    updateControl("docType", matched || type);
  }}
/>

          <Stack spacing={0.5} mt={1}>
  {control.files.map(file => {
    const isSelected =
      selectedFile &&
      selectedFile.name === file.name &&
      selectedFile.size === file.size;

    return (
      <Stack
        key={file.name}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          px: 1,
          py: 0.5,
          borderRadius: 1,
          cursor: "pointer",
          bgcolor: isSelected ? "#9e9e9e" : "#f5f5f5", // dark grey
          color: isSelected ? "#fff" : "inherit",
          "&:hover": {
            bgcolor: isSelected ? "#8c8c8c" : "#eaeaea"
          }
        }}
        onClick={() => setSelectedFile(file)}
      >
        <Typography fontSize={13} sx={{ flexGrow: 1 }}>
          {file.name}
        </Typography>

        <IconButton
          size="small"
          onClick={e => {
            e.stopPropagation();
            removeFile(file);
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Stack>
    );
  })}
</Stack>
        </>
      )}
    </Box>
  );
}